import { Component } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
    selector: 'offline-report',
    templateUrl: './offline-component.html',
    styleUrls: ['./offline-component.css']
})

export class OfflineReportComponent {
    localStorage: any;
    orgAllVehicle: any;
    showTable: boolean = false;
    offlineVehicles: any = [];
    // xlData
    public cols = [
        { key: '#', display: '#' },
        { key: 'regNo', display: 'Reg no', config: { isVehicle: true, } ,headerConfig:{ isDefault: true}},
        { key: 'lastUpdate', display: 'Date / Time',headerConfig:{ isDefault: true} },
        { key: 'location', display: 'Location' },

    ];

    constructor(
        private api: ApiService,
        private storage: StorageService,
        private comService: CommonServices,
        private excel: ExcelExportService
    ) {
        this.localStorage = this.storage.get('userInfo');

    }

    ngOnInit() {

        const obj = {
            orgID: this.localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
        };
        this.api.transportManagerVehicleList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.orgAllVehicle = res && res.data;
            }
        });
        setTimeout(() => {
            this.getReports();
        }, 300)
    }

    getReports() {
        this.api.getCurrentLocation({}).then((res: any) => {
            if (res.status == 'success') this.getValidateVehicle(res['data']);
        });
    }

    getValidateVehicle(latestData) {
        this.offlineVehicles = [];
        let inc = 1;
        const currnentTMS = new Date().getTime();
        for (let i = 0; i < this.orgAllVehicle.length; i++) {

            let regNo = this.orgAllVehicle[i]['vehRegNo'];
            // latestData.filter((item)=>{
            //     return regNo== JSON.parse(item)['reg'];
            // });

            for (let l = 0; l < latestData.length; l++) {
                let vehicle = JSON.parse(latestData[l]);
                //  if(regNo!==vehicle['reg']) offlineVehicles.push(this.orgAllVehicle[i]);
                //  else {
                const timeDiff = this.comService.timeDiff(vehicle.gpsts, currnentTMS);
                if (regNo == vehicle['reg'] && timeDiff && timeDiff.hh > 72) {
                    this.offlineVehicles.push({
                        "S.No": inc++,
                        "regNo": vehicle['reg'].toUpperCase(),
                        "lastUpdate": this.comService.timestampToDate(vehicle['gpsts'], 'DMY H:M:S', '-'),
                        "location": String(vehicle['near']).replace('\r', ''),
                    });
                }
                //  }
            }
        }
        this.showTable = true;
        // console.log('offlineVehicles ---> ', this.offlineVehicles)
    }

    downloadXl() {

        let rowCount = 2;
        let endCell = 'D';
        let customizedData = [];
        let titleRow = {
            value: ['Offline Report'],
            font: {
                name: 'Corbel', family: 4, size: 16, bold: true,
                color: { argb: 'FFFFFFFF' },

            },
            mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
            alignment: {
                cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
            },
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '966462AF' },
                bgColor: { argb: '966462AF' }
            },
        }

        customizedData.push(titleRow);

        rowCount = rowCount + 1;

        let dividerRow = {
            value: [],
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFFFF' },
                bgColor: { argb: 'FFFFFFFF' }
            },
            mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }

        customizedData.push(dividerRow);

        rowCount = rowCount + 1;
        let headerRow =
        {
            value: ['S No', 'Vehicle ', 'Date / Time', 'Location'],
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF00' },
                bgColor: { argb: 'FF0000FF' }
            },
            font: { bold: true },
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
        customizedData.push(headerRow);

        let xlData = [];
        for (let xl = 0; xl < this.offlineVehicles.length; xl++) {
            let rowVal = {
                value: Object.values(this.offlineVehicles[xl])
            }
            xlData.push(rowVal);
        }

        customizedData.push(...xlData);

        // const excelInfo = {
        //     title: {
        //         title: 'Offline Report',
        //         //   subTitleRow: 'Date : ' + startDate + ' to ' + endDate,
        //         font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
        //         mergeCells: 'A1:G2',
        //     },
        //     header: {
        //         headers: ['S.No', 'Vehicle ', 'Date/Time', 'Location'],
        //         fill: {
        //             type: 'pattern',
        //             pattern: 'solid',
        //             fgColor: { argb: 'FFFFFF00' },
        //             bgColor: { argb: 'FF0000FF' }
        //         },
        //         border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        //     },
        //     data: {
        //         data: xlData,
        //         columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 15 }, { colNo: 3, width: 30 }, { colNo: 4, width: 100 }]
        //     }
        // };

        let excelData: any = {};
        excelData['Offline-Report'] = {
            customizedData: customizedData,
            data: {
                columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 15 }, { colNo: 3, width: 30 }, { colNo: 4, width: 100 }]
            }
        };
        //excelInfo;

        this.excel.generateExcel(excelData, 'Offline_Report_' + this.comService.timestampToDate(new Date().getTime(),'DMY' )  + '.xlsx');

    }
}
